import type { DataMap } from "./mapper";

// The profile has no "currently studying" flag, only a free-text year. A float
// education marked currently studying is saved to the profile with this as its
// year, and turned back into the flag when profile education is mapped in.
export const CURRENTLY_STUDYING = "Currently studying";

export const isCurrentlyStudying = (year?: string | null) =>
  typeof year === "string" && year.trim().toLowerCase() === CURRENTLY_STUDYING.toLowerCase();

const education: DataMap = {
  id: "id",
  name: "course_name",
  provider: "institution",
  period: (e) => (isCurrentlyStudying(e.year_completed) ? "" : e.year_completed),
  currently_studying: (e) => isCurrentlyStudying(e.year_completed),
  logo: ["logo", "company_logo"],
};

export default education;
